import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Contract } from '@shared/entities/contract';
import { ApiService } from '@shared/services';
import { Observable, interval, shareReplay, startWith, switchMap } from 'rxjs';

const TIME_INTERVAL = 180000;

@Injectable({
  providedIn: 'root'
})
export class ContractAlertService extends ApiService<Contract> {
  /**
   * Observable that emits the list of contracts that are lapsed (SCADUTO,IN SCADENZA)
   */
  lapsed$: Observable<Contract[]>;

  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/contracts';
    const detailUrl = '/contracts';

    super(Contract, masterUrl, detailUrl, 'contracts');

    this.lapsed$ = interval(TIME_INTERVAL).pipe(
      startWith(0),
      switchMap(() => {
        const { locationId } = this.activatedRoute.snapshot.queryParams;
        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }
        this.setUrlParameter('state', 'SCADUTO,IN SCADENZA');
        return this.findAll();
      }),
      shareReplay(1)
    );
  }
}
